<script lang="ts">
	import Header from '$lib/components/TitleHeader.svelte';
	import Content from '$lib/components/PolicyContent.svelte';
	import { termsIntro, termsSections, pageTitle } from '$lib/components/privacy-policy/config';
	import { absoluteUrl } from '$lib/seo/publicBase';
	import { PRIVACY_POLICY_META_DESCRIPTION } from '$lib/seo/privacy-policy';

	const docTitle = `${pageTitle} | AngelOne Fincap`;
	const canonical = absoluteUrl('/privacy-policy/');
</script>

<svelte:head>
	<title>{docTitle}</title>
	<meta name="description" content={PRIVACY_POLICY_META_DESCRIPTION} />
	{#if canonical}
		<link rel="canonical" href={canonical} />
	{/if}
	<meta property="og:type" content="website" />
	<meta property="og:title" content={docTitle} />
	<meta property="og:description" content={PRIVACY_POLICY_META_DESCRIPTION} />
	{#if canonical}
		<meta property="og:url" content={canonical} />
	{/if}
	<meta name="twitter:card" content="summary" />
	<meta name="twitter:title" content={docTitle} />
	<meta name="twitter:description" content={PRIVACY_POLICY_META_DESCRIPTION} />
</svelte:head>

<Header title={pageTitle} />
<Content introText={termsIntro} sections={termsSections} />
